import React, { useState, useEffect } from 'react'
import { convertFromRaw } from 'draft-js'
import { LinkContainer } from 'react-router-bootstrap'
import './VideoCard.css'

const ImageComponent = ({ image, title }) => {
  const imageUrl = image.startsWith('https://satnam-bucket')
    ? image
    : `${process.env.REACT_APP_BASE_URL}${image}`

  return <img src={imageUrl} alt={title} className="video-image" />
}

const VideoCard = ({
  id,
  title,
  image,
  description,
  free,
  date_of_creation,
  is_staff,
}) => {
  const [contentState, setContentState] = useState(null)

  useEffect(() => {
    if (!description) return
    try {
      const raw = JSON.parse(description)
      const state = convertFromRaw(raw)
      setContentState(state)
    } catch (e) {
      console.error('Error parsing description JSON', e)
    }
  }, [description])

  const getPlainTextPreview = (state) => {
    if (!state) return ''
    const fullText = state.getPlainText('\n')
    const maxLength = 220
    return fullText.length > maxLength
      ? fullText.slice(0, maxLength) + '…'
      : fullText
  }

  const previewText = getPlainTextPreview(contentState)

  const detailedPath = `/video-detailed/${id}/${encodeURIComponent(title)}`

  return (
    <div className="video-card">
      <div className="video-card-top">
        {free && <span className="video-badge-free">Gratis</span>}
        <span className="video-tag">Kundalini Yoga</span>
      </div>

      <h3 className="video-title">{title}</h3>

      <LinkContainer to={detailedPath}>
        <div className="video-image-container">
          <ImageComponent image={image} title={title} />
          <div className="video-image-overlay">
            <div className="video-overlay-text">
              Sesión de Kundalini Yoga para trabajar cuerpo, mente y energía.
            </div>
          </div>
          <div className="play-icon">▶</div>
        </div>
      </LinkContainer>

      {previewText && (
        <p className="video-description">{previewText}</p>
      )}

      <div className="video-card-bottom">
        <LinkContainer to={detailedPath}>
          <a className="video_link">Ver clase completa</a>
        </LinkContainer>
        <p className="video-card-date">
          Creado el: {new Date(date_of_creation).toLocaleDateString()}
        </p>
      </div>
    </div>
  )
}

export default VideoCard
